var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#5E5E66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.25C7.0335 1.25 6.25 2.0335 6.25 3V4H5.05501H2.75C2.33579 4 2 4.33579 2 4.75C2 5.16421 2.33579 5.5 2.75 5.5H4.08036L4.69929 17.0535C4.72773 17.5842 5.16636 18 5.69786 18H14.3021C14.8336 18 15.2723 17.5842 15.3007 17.0535L15.9196 5.5H17.25C17.6642 5.5 18 5.16421 18 4.75C18 4.33579 17.6642 4 17.25 4H14.945H13.75V3C13.75 2.0335 12.9665 1.25 12 1.25H8ZM12.25 4V3C12.25 2.86193 12.1381 2.75 12 2.75H8C7.86193 2.75 7.75 2.86193 7.75 3V4H12.25ZM5.58251 5.5H14.4175L13.8282 16.5H6.17179L5.58251 5.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.cd6671ff.svg";
export { ForwardRef as ReactComponent };